@for (attachment of formArray?.controls; track attachment; let i = $index) {
  <div class="file-info">
    <div class="u-flex">
      <icon
        class="file-info__icon"
        name="pdf"
        [config]="{
          format: 'svg',
          size: 'medium',
        }"
      >
      </icon>
      <p class="file-info__name">{{ attachment?.value?.name }}</p>
    </div>
    <p class="file-info__size">
      {{ attachment?.value?.size | filesize }}
    </p>
    @if (showCloseIcon) {
      <icon
        class="file-info__close"
        name="close"
        [config]="{
          format: 'svg',
          size: 'small',
        }"
        (click)="closeClicked.emit(i)"
      >
      </icon>
    }
  </div>
  <div class="progressbar">
    @if (i + 1 === formArray?.controls?.length && total) {
      <div class="progressbar__total">
        <div
          [ngClass]="{ progressbar__error: error }"
          class="progressbar__partial"
          [ngStyle]="progressWidth"
        ></div>
      </div>
      @if (!error) {
        <p class="progressbar__percentage">{{ total }}% done</p>
      }
    } @else {
      <div class="progressbar__total">
        <div
          [ngClass]="{ progressbar__error: error }"
          class="progressbar__partial"
        ></div>
      </div>
      @if (!error) {
        <p class="progressbar__percentage">100% done</p>
      }
    }
    <ng-template #done>
      <div class="progressbar__total">
        <div
          [ngClass]="{ progressbar__error: error }"
          class="progressbar__partial"
        ></div>
      </div>
      @if (!error) {
        <p class="progressbar__percentage">100% done</p>
      }
    </ng-template>
  </div>
}
